export enum WalletPlatformEnum {
  Ethereum = "ethereum",
  Polygon = "polygon",
}
